


<template>
<div class="demo-menu">
    <div class="menu-panel">
      <h1>Health & Benefits Flex Demo  <small>v{{ $store.state.version }}</small></h1>
      <p>Welcome, and thank you for taking the time to see a demo of Paychex FLEX, our all-in-one cloud-based solution for managing your benefit programs, and much more.</p>

      <p>Display this menu at any time by pressing <span class="button-code">SPACE</span></p>
      <p>To preview active links on a screen, press <span class="button-code">SHIFT</span></p>

      <div class="menu-buttons">
        <div class="">
          <button :data-active="guidedMode" @click="onSetGuided(true)">Guided Mode</button>
          <button :data-active="!guidedMode"  @click="onSetGuided(false)">Expert Mode</button>
        </div>
        <div>
          <button  @click="goFullscreen">Toggle Fullscreen</button>
        </div>

      </div>
    </div>

</div>
</template>

<script>
export default {
    name: "demo-menu",
    props: {},
    data: function(){
        return {}
        },
    mounted: function(){
      document.onfullscreenchange = ()=>{
        this.$store.commit("fullscreen", document.fullscreenElement?true:false)
      }
    },
    methods: {
      onSetGuided: function(guided){

        //this.guidedMode = guided;
        //this.showMenu = false;

        this.$store.commit("guidedMode", guided);
        this.$store.commit("showMenu", false);

      },
      goFullscreen: function(){
        if(document.fullscreenElement){

          document.exitFullscreen();

        }else{

          document.getElementById("app").requestFullscreen();

        }
      }
    },
    computed: {
      guidedMode: function(){
        return this.$store.state.guidedMode;
      },
    }
}
</script>

<style scoped>


.demo-menu {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.demo-menu .menu-panel {
  width: 50%;
  box-sizing: border-box;
  padding: 5%;
  background-color: var(--color-green);
  color: white;
  border: 10px solid white;
}

.menu-panel h1 {
  margin: 0;
  border-bottom: 2px solid white;
  padding-bottom: 0.5em;
  margin-bottom: 1em;
}

.button-code {

  border: 1px solid white;
  padding: 0.25em 0.5em;
  margin: 0 0.25em;
  border-radius: 0.5em;
  font-family: monospace;
}

.menu-buttons {
  border-top: 1px solid white;
  padding-top: 1em;
  margin-top: 2em;
  display: flex;
  justify-content: space-between;

}

.menu-buttons button {
  font-size: 1em;
  border: 1px solid white;
  padding: 1em;
  background: transparent;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  outline: none;

}

.menu-buttons button:hover {
  text-decoration: underline;
}

.menu-buttons button[data-active="true"] {
  background-color: white;
  color: var(--color-green);
}

.menu-buttons button + button {
  margin-left: 1em;
}

.menu-panel small {
  font-size: 0.7em;
  font-weight: normal;
}

</style>